import MapComponent from "components/MapComponent/MapComponent";
// import OptionList from "components/OptionList/OptionList";
// import asset from "json/assets";
import MapWrapper from "layout/MapWrapper/MapWrapper";
// import styles from "styles/pages/Map1.module.scss";
// import stylesRightList from "styles/component/RightList.module.scss";
// import ListTableContent from "components/ListTableContent/ListTableContent";
// import stylesPopOver from "styles/component/PopOver.module.scss";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
	driving_range_gps_details,
	setIsNewRange,
	setMapData,
	setVisibleArea,
} from "redux/MapSlice";
import {
	configElevationDataPromise,
	convertAPIResposeToUsableShape,
	decryptSecretKey,
	getModalProperties,
} from "services/utils";
import { drivingRange_details, rangeInfo_details } from "redux/RangeInfoSlice";
import NoDataAvailable from "pages/NoDataAvailable/NoDataAvailable";
import MapLoader from "pages/MapLoader/MapLoader";
import BackdropLoader from "ui/BackdropLoader/BackdropLoader";
import {
	useDrivingRangeGPSCreateStatus,
	useDrivingRangeGPSUpdateStatus,
} from "hooks/MapDetails";
import { useProfileUsername } from "hooks/ProfileDetails";
import MapNotFound from "components/MapNotFound/MapNotFound";
import useNotiStack from "hooks/useNotistack";
import {
	course_elevation_data_details,
	course_gps_vector_details,
	course_json_data,
	setHeatMapData,
} from "redux/HeatMapSlice";
import { dummyHeat, elevationDetails } from "API/dummyHeat";
import { point } from "@turf/turf";
import {
	course_gps_name_list,
	course_map_gps_mapping_details,
	course_map_gps_vector_details,
	course_mapping_note_list,
	course_scorecard_details,
	fetch_google_geocode,
	setCourseGPSMappingData,
} from "redux/CourseMapSlice";
import { clearSearchedCourseName, course_details } from "redux/CourseSlice";
import { useAssociatedCourseData } from "hooks/RangeDetails";
// import { dummyGPS } from "API/dummyCourseGPSVector";
import * as _ from "underscore";
import { useNavigate } from "react-router-dom";
import { useEventEmitter } from "hooks/useEventEmitter";
import events from "json/events";
import eventEmitter from "services/event.emitter";
import { useGlobalSaveStatus } from "hooks/CourseMapDetails";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";

export const MapContext = React.createContext();

export default function MapView() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	// const messageTimeout = 4000;
	const { toastError, toastInfo } = useNotiStack();

	const params = useParams();
	const mapType = params?.type;
	const [searchParams] = useSearchParams();
	const secret_Key = decryptSecretKey();
	const username = useProfileUsername();
	const mapCreateStatus = useDrivingRangeGPSCreateStatus();
	const mapUpdateStatus = useDrivingRangeGPSUpdateStatus();
	const globalSaveStatus = useGlobalSaveStatus();
	const courseData = useAssociatedCourseData();

	const id_drivingRangeFromQuery = searchParams.get("range");
	const id_courseFromQuery = searchParams.get("course");

	const [mapLoading, setMapLoading] = useState(true);
	const [isMapError, setIsMapError] = useState(false);
	const [isRestrictedCourse, setIsRestrictedCourse] = useState(false);
	const modalProperties = getModalProperties();

	const [refinedData, setRefinedData] = useState({});

	const errorDisplay = (errMsg) => {
		setMapLoading(false);
		setIsMapError(true);
		toastError(errMsg ? errMsg : "Something went wrong!");
	};

	useEffect(() => {
		// maybe open map after checking redux state has filled
		setIsMapError(false); //resetting prev error state
		if (username && id_drivingRangeFromQuery) {
			if (window.location.pathname?.includes("rangemap")) {
				dispatch(
					driving_range_gps_details({
						body: {
							id_drivingRange: id_drivingRangeFromQuery,
						},
						user: {
							secretKey: secret_Key,
							userName: username,
						},
					}),
				)?.then((res) => {
					if (res?.payload?.data?.Status === 1) {
						// A range with shapes already added
						setMapLoading(false);
						let convertedShapeData = convertAPIResposeToUsableShape(
							res?.payload?.data?.shapes,
						);
						let reduxObject = {
							info: res?.payload?.data?.info,
							shapes: convertedShapeData,
						};

						let visibleAreaList = [];
						Object.values(convertedShapeData)?.map((zoneItem, index) => {
							zoneItem?.map((item, index) => {
								visibleAreaList.push(item?.label);
							});
						});
						dispatch(setVisibleArea(visibleAreaList));
						dispatch(setMapData(reduxObject)); // turned off because of lag
						//  dispatch(setMapData(dummy)); //testing purpose

						dispatch(setIsNewRange(false));
					} else if (
						res?.payload?.data?.Status !== 1 &&
						res?.payload?.data?.Status === 501
					) {
						// API responds with error
						errorDisplay();
					} else {
						// a new range with no previous shapes added
						setMapLoading(false);
						dispatch(setIsNewRange(true));
					}
				});
			}

			//course elevation data
			else if (window.location.pathname?.includes("heatmap")) {
				// Create an array of promises for each dispatch
				const promises = [
					new Promise((resolve, reject) => {
						dispatch(
							course_gps_vector_details({
								body: {
									id_course: id_drivingRangeFromQuery,
								},
								user: {
									secretKey: secret_Key,
									userName: username,
								},
							}),
						)
							.then((res) => {
								if (res?.payload?.data?.Status !== 501) {
									resolve(res);
								} else {
									reject("GPS details not found!");
								}
							})
							.catch(reject);
					}),
					new Promise((resolve, reject) => {
						dispatch(
							course_elevation_data_details({
								body: {
									id_course: id_drivingRangeFromQuery,
								},
								user: {
									secretKey: secret_Key,
									userName: username,
								},
							}),
						)
							// .then(resolve)
							.then((res) => {
								if (res?.payload?.data?.Status !== 501) {
									resolve(res);
								} else {
									reject("Elevation details not found!");
								}
							})
							.catch(reject);
					}),
				];
				// Use Promise.all to wait for all promises to complete
				Promise.all(promises)
					.then((results) => {
						// All API calls were successful
						const [gpsVectorResult, elevationDataResult] = results;
						// Extract the data you need from elevationDataResult
						const fileUrl = elevationDataResult?.payload?.data?.jsonFullUrl;

						// Dispatch the course_json_data action with the data from elevationDataResult

						dispatch(course_json_data(fileUrl))
							.then((jsonDataResult) => {
								// Handle jsonDataResult if needed

								let result = configElevationDataPromise(
									jsonDataResult?.payload,
								);
								result.then((data) => {
									let rdxObj = {
										avgElevationValue: data.averageElevation,
										maxElevationValue: data.maxElevation,
										minElevationValue: data?.minElevation,
										label: "HEAT1",
										type: "point",
										zone: "EXPE",
										list: data.elevationDetails,
										HeatMapJSONArray: data.HeatMapJSONArray,
										...jsonDataResult?.payload,
									};

									// Dispatch or do further processing as needed
									setRefinedData(rdxObj);
									// setMapLoading(false);
									eventEmitter.emit(events.toggleMapLoadingScreen, false);
								});
							})
							.catch((error) => {
								// Handle any error from the course_json_data dispatch
								console.error("course_json_data dispatch failed:", error);
								// Display an error message to the user if needed
							});
					})
					.catch((error) => {
						// At least one API call failed
						console.error("One or more API calls failed:", error);
						errorDisplay(error);
						// Handle the error and display an error message to the user
					});
			}
		}

		// course map data
		if (username && id_courseFromQuery) {
			//===================================================call API

			const checkCourseExists = () => {
				eventEmitter.emit(events.toggleMapLoadingScreen, true);

				return new Promise((resolve, reject) => {
					const __promises = [
						new Promise((resolve, reject) => {
							dispatch(
								course_map_gps_vector_details({
									body: {
										id_course: id_courseFromQuery,
									},
									user: {
										secretKey: secret_Key,
										userName: username,
									},
								}),
							)
								.then((res) => {
									if (res?.payload?.data?.Status !== 501) {
										resolve(res);
									} else {
										reject("Vector details not found!");
									}
								})
								.catch(reject);
						}),

						new Promise((resolve, reject) => {
							dispatch(
								course_gps_name_list({
									body: {
										id_course: id_courseFromQuery,
									},
									user: {
										secretKey: secret_Key,
										userName: username,
									},
								}),
							)
								.then((res) => {
									if (res?.payload?.data?.Status !== 501) {
										resolve(res);
									} else {
										reject("name list not found!");
									}
								})
								.catch(reject);
						}),
						new Promise((resolve, reject) => {
							dispatch(
								course_map_gps_mapping_details({
									body: {
										id_course: id_courseFromQuery,
									},
									user: {
										secretKey: secret_Key,
										userName: username,
									},
								}),
							)
								.then((res) => {
									if (res?.payload?.data?.Status !== 501) {
										resolve(res);
									} else {
										reject("Vector details not found!");
									}
								})
								.catch(reject);
						}),
						new Promise((resolve, reject) => {
							dispatch(
								course_scorecard_details({
									body: {
										id_course: id_courseFromQuery,
									},
									user: {
										secretKey: secret_Key,
										userName: username,
									},
								}),
							)
								// .then(resolve)
								.then((res) => {
									if (res?.payload?.data?.Status !== 501) {
										resolve(res);
									} else {
										reject("Scorecard details not found!");
									}
								})
								.catch(reject);
						}),

						new Promise((resolve, reject) => {
							dispatch(
								course_mapping_note_list({
									body: {
										id_course: id_courseFromQuery,
									},
									user: {
										secretKey: secret_Key,
										userName: username,
									},
								}),
							)
								// .then(resolve)
								.then((res) => {
									if (res?.payload?.data?.Status !== 501) {
										resolve(res);
									} else {
										reject("Mapping Note details not found!");
									}
								})
								.catch(reject);
						}),
					];

					Promise.all(__promises)
						.then((results) => {
							// All API calls were successful
							const [
								course_map_gps_vector_details_response,
								course_gps_name_list_response,
								course_mapping_gps_details,
								course_scorecard_details,
								course_mapping_note_list,
							] = results;

							// YamaTrack Fleet Course restriction check
							const RESTRICTION_NOTE_TEXT =
								"2026 YamaTrack Fleet Course. Requires Special Permission to Update.";
							const ALLOWED_ADMIN_IDS = [17, 192, 196];
							const noteList =
								course_mapping_note_list?.payload?.data?.noteList;
							const hasRestriction = noteList?.some(
								(note) =>
									note?.id_adminUser === 17 &&
									note?.note === RESTRICTION_NOTE_TEXT,
							);
							if (hasRestriction) {
								const currentUserId = Number(
									localStorage.getItem("id_adminuser"),
								);
								if (!ALLOWED_ADMIN_IDS.includes(currentUserId)) {
									setIsRestrictedCourse(true);
								}
							}

							if (
								(!course_mapping_gps_details?.payload?.data?.clubLat ||
									course_mapping_gps_details?.payload?.data?.clubLat === -1) &&
								(!course_mapping_gps_details?.payload?.data?.clubLon ||
									course_mapping_gps_details?.payload?.data?.clubLon === -1)
							) {
								// toastInfo(
								//   "Course location not found in database. Swtiching to Google Geocode."
								// );
								dispatch(
									course_details({
										body: {
											id_courseInt: Number(id_courseFromQuery),
											stateFormat: 4,
											countryFormat: 4,
											detailLevel: 2,
											// id_course: courses
										},
										user: {
											secretKey: secret_Key,
											userName: username,
										},
									}),
								)
									.then((res) => {
										if (res?.payload?.data?.Status !== 501) {
											let fetchAddress = "";
											if (res?.payload?.data.courseName) {
												fetchAddress = res?.payload?.data.courseName;
											}
											if (res?.payload?.data.address1) {
												fetchAddress =
													fetchAddress + "," + res?.payload?.data.address1;
											}
											if (res?.payload?.data.address2) {
												fetchAddress =
													fetchAddress + "," + res?.payload?.data.address2;
											}
											if (res?.payload?.data.city) {
												fetchAddress =
													fetchAddress + "," + res?.payload?.data.city;
											}
											if (res?.payload?.data.stateFull) {
												fetchAddress =
													fetchAddress + "," + res?.payload?.data.stateFull;
											}

											if (res?.payload?.data?.zipCode) {
												fetchAddress =
													fetchAddress + "," + res?.payload?.data.zipCode;
											}
											dispatch(
												fetch_google_geocode({ address: fetchAddress }),
											).then((result) => {
												if (result?.payload?.results?.length) {
													// setMapLoading(false);
													resolve("Course found!");
												} else {
													// clearing searched course name if loaction was not found. prevents page loop
													dispatch(clearSearchedCourseName());
													navigate(-1);
													toastError(
														"Google Geocoding responded with 0 results",
													);
												}
											});
										} else {
											console.error("Course details not found!");
											reject("Course details not found!");
										}
									})
									.catch((err) => {
										console.error("Course details not found!", err);
										reject("Course details not found!");
									});
							} else {
								// setMapLoading(false);
								resolve("Course found!");
							}
						})
						.catch((error) => {
							console.error("One or more API calls failed:", error);
							errorDisplay(error);
							reject("One or more API calls failed");
						});
				});
			};

			checkCourseExists().finally(() => {
				eventEmitter.emit(events.toggleMapLoadingScreen, false);
			});

			// setMapLoading(false);
		}

		//need to send Map data to redux
	}, [id_drivingRangeFromQuery, id_courseFromQuery, username]);

	const getMapHeaderTitle = (mapType) => {
		const headers = {
			rangemap: "DRIVING RANGE",
			heatmap: "HEAT MAP",
			coursemap: "COURSE MAP",
		};
		return headers[mapType];
	};

	useEventEmitter(events.toggleMapLoadingScreen, setMapLoading);

	// The old Leaflet heatmap view was retired; the new Three.js editor lives at
	// /heatmapeditor. Redirect any stale /mapview/heatmap deep link to the list.
	if (mapType === "heatmap") return <Navigate to="/heatmap" replace />;

	return (
		<MapWrapper
			title={getMapHeaderTitle(mapType)}
			//  title={mapType === "rangemap" ? "DRIVING RANGE" : "HEAT MAP"}
		>
			<BackdropLoader
				open={mapCreateStatus === "loading" ? true : false}
				// open

				text="Saving..."
			/>
			<BackdropLoader
				open={mapUpdateStatus === "loading" ? true : false}
				// open
				text="Updating..."
			/>
			<BackdropLoader
				open={courseData?.course_details_status === "loading" ? true : false}
				// open

				text="Fetching map data..."
			/>
			{/* course sync output create create api throw error */}
			{/* <BackdropLoader
        open={globalSaveStatus === "loading" ? true : false}
        // open
        text="Savingvbcv..."
      /> */}

			<ModalWrapper open={isRestrictedCourse} noOnClose>
				<NoificationModal
					label="Error"
					backgroundColor={modalProperties.error.backgroundColor}
					image={modalProperties.error.icon}
					title="<b>Special Permission Required</b>"
					content="This course requires special permission to update. Contact the US office if changes are required."
					affrCallBack={() => navigate("/coursemap")}
					affrBtnTxt="OK"
					hideRejectBtn
				/>
			</ModalWrapper>

			{mapLoading ? (
				// <span>Loading...</span>
				<MapLoader />
			) : !isMapError ? (
				<MapContext.Provider value={refinedData}>
					<MapComponent mapType={mapType} />
				</MapContext.Provider>
			) : (
				// "ERR"
				<MapNotFound />
			)}

			{/* <div className={styles.right_list}>
        <div className={stylesRightList.side_list}>
          <ul>
            {array.map((data, index) => {
              return (
                <li>
                  <OptionList
                    index={index}
                    icon={data?.icon}
                    isIcon={data?.isIcon}
                    title={data?.title}
                    isData={data?.isData}
                   
                  />
                  
                  
                </li>
              );
            })}
          </ul>
          <ul>
            {array1.map((data, index) => {
              return (
                <li>
                  <OptionList
                    index={index}
                    icon={data?.icon}
                    isIcon={data?.isIcon}
                    title={data?.title}
                    isData={data?.isData}
                    optionListStyleTwo={data?.optionListStyleTwo}
                    noTable={data?.noTable}
                  >
                  </OptionList>
                </li>
              );
            })}
          </ul>
        </div>
      </div> */}
		</MapWrapper>
	);
}
